<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add value="添加承租单位" :pathName="addBusinessRouterName" v-if="permissionCodes.indexOf('001004001') !== -1"/>
        <button-delete @deleteSelection="deleteSelection" v-if="permissionCodes.indexOf('001004002') !== -1"/>
<!--        <button-upload :cathUrl="uploadUrl" :onSuccess="uploadSuccess" @getpage="getPage" value="导入"/>-->
<!--        <button-export :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" v-if="permissionCodes.indexOf('001004004') !== -1" value="导出"/>-->
      </div>
      <input-search placeholder="单位名称" @search="searchKey" />
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" deleteTipInfo="是否确认删除此单位？" @deleteLine="deleteLine" @toCurrentPage="toCurrentPage" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" tableOperationWidth="180px" @allocateListings="showAllocateListingsVisible" @modifyListings="showModifyAllocateListingsVisible" @deleteListings="delLeaseRoomBindByCodes"/>

    <el-dialog title="分配房源" :visible.sync="allocateListingsVisible" width="800px">
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">房间号：</span>
          </div>
          <el-select v-model="allocateListingsRoomCode" filterable remote reserve-keyword placeholder="请输入关键词查询" size="mini" style="width: 280px" :remote-method="roomInfoMethod" @change="changeAllocateListingsRoomCode">
            <el-option v-for="item in roomList" :key="item.code" :label="item._label" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="form-line" v-if="bedsListInRoom.length > 0">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">床位：</span>
          </div>
          <el-select v-model="bedChooseCode" multiple placeholder="请选择床位" size="mini" style="width: 280px">
            <el-option v-for="item in bedsListInRoom" :key="item.code" :label="item.bedsNumber" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租金：</span>
          </div>
          <el-input v-model="rentPrice" size="small" style="width: 280px" >
            <el-select v-model="rentPriceUnit" slot="append" style="width: 120px;">
              <el-option v-for="item in rentPriceUnitList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-input>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租赁起始时间：</span>
          </div>
          <el-date-picker v-model="leaseStartTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择租赁起始时间" size="small" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租赁结束时间：</span>
          </div>
          <el-date-picker v-model="leaseStopTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择租赁结束时间" size="small" style="width: 280px" />
        </div>
      </form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="allocateListingsVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="allotEnterpriseLeaseRoom" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改房源" :visible.sync="modifyAllocateListingsVisible" width="800px">
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">房间号：</span>
          </div>
          <el-input v-model="modifyAddAllocateListings.roomNumber" size="small" style="width: 280px" disabled />
        </div>
        <div class="form-line" v-if="modifyAddAllocateListings.bedsNumber">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">床位：</span>
          </div>
          <el-input v-model="modifyAddAllocateListings.bedsNumber" size="small" style="width: 280px" disabled />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租金：</span>
          </div>
          <el-input v-model="modifyAddAllocateListings.price" size="small" style="width: 280px" >
            <el-select v-model="modifyAddAllocateListings.priceUnit" slot="append" style="width: 120px;">
              <el-option v-for="item in modifyRentPriceUnitList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-input>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租赁起始时间：</span>
          </div>
          <el-date-picker v-model="modifyAddAllocateListings.leaseStartTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择租赁起始时间" size="small" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租赁结束时间：</span>
          </div>
          <el-date-picker v-model="modifyAddAllocateListings.leaseStopTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择租赁结束时间" size="small" style="width: 280px" />
        </div>
      </form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modifyAllocateListingsVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="updateLeaseRoomBind" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/LeaseManage'
import {errorHandler} from '../../../utils/errorHandler'
import {nAlert, nError, nSuccess} from '../../../utils/notice'
import {bus} from '../../../utils/bus'
import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
import {deepCloneFunction} from "../../../tool/tools";

export default {
  components: {
    ButtonConfirmNext,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb},
  name: 'business-management',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '资源中心',
        name: 'yq-information'
      }, {
        value: '单位承租'
      }],
      addBusinessRouterName: 'business-add',
      selectTitle: '租赁状态',
      leaseStateList: [{
        label: '全部',
        key: ''
      }, {
        label: '在租',
        key: '0'
      }, {
        label: '临近租期',
        key: '1'
      }, {
        label: '已到期',
        key: '2'
      }],
      exportUrl: '',
      uploadUrl: '',
      tableHead: [
        {prop: 'leaseRoomBindList', label: '', hasExpand: true, tableHead: [{prop: 'leaseRoomNumberLabel', label: '房间号'}, {prop: 'roomArea', label: '房间面积(m²)'}, {prop: 'roomType', label: '房间类型'}, {prop: 'bedsNumber', label: '床位编号'}, {prop: 'price', label: '租金(元)'}, {prop: 'leaseStartTime', label: '租赁起始时间'}, {prop: 'leaseStopTime', label: '租赁结束时间'},]},
        {prop: 'enterpriseName', label: '单位名称'},
        {prop: 'taxpayerRegisterNumber', label: '纳税人识别号'},
        {prop: 'personName', label: '申请人姓名'},
        {prop: 'phone', label: '申请人手机号'},
        {prop: 'identityNumber', label: '申请人身份证'},
        {prop: 'rentTypeText', label: '申请房型'},
        {prop: 'stayStartTime', label: '预入住日期'},
        {prop: 'leaseTimeLimit', label: '预租期限'},
        {prop: 'statusText', label: '状态'},
        {prop: 'remarks', label: '备注'}
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      operationArr: ['current', 'delete'],
      selectionArr: [],
      requestData: {
        searchKey: '',
        rentStatus: ''
      },


      allocateListingsVisible: false,
      dialogInputWidth: '120px',
      addAllocateListings: {
        code: '',
        rooms: []
      },
      leaseStartTime: '',
      leaseStopTime: '',
      allocateListingsRoomCode: '',
      roomList: [],
      bedChooseCode: '',
      bedsListInRoom: [],
      rentPrice: '',
      rentPriceUnit: '2',
      rentPriceUnitList: [
        {code: '2', name: '间 / 元 / 月'},
        {code: '1', name: '间 / 元 / 天'},
      ],

      modifyAllocateListingsVisible: false,
      modifyDialogInputWidth: '120px',
      modifyAddAllocateListings: {},
      modifyRentPriceUnitList: [
        {code: '2', name: '间 / 元 / 月'},
        {code: '1', name: '间 / 元 / 天'},
      ]
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.uploadUrl = api.importEnterpriseInfo
  },
  activated() {
    this.getPage()
    this.roomInfoMethod()
  },
  methods: {
    // 查询房源
    roomInfoMethod (query) {
      this.getRoomInfoList(query)
    },
    // 获取房源列表
    getRoomInfoList (searchKey) {
      this.$axios.post(api.getRoomInfoList, {
        searchKey: searchKey || ''
      })
        .then(res => {
          let data = res.data.data || []
          data.map(v => {
            v._label = `${v.buildingName}/${v.floorName}层/${v.roomNumber}/${v.roomType || ''}`
          })
          this.roomList = data
        })
        .catch(errorHandler('获取房源列表失败'))
    },

    changeAllocateListingsRoomCode (value) {
      this.roomList.map(v => {
        if (v.code === value) {
          let room = [], bedsListInRoom = []
          room = [
            {
              code: v.code,
              roomNumber: v.roomNumber,
              beds: [],
              leaseStartTime: '',
              leaseStopTime: '',
              price: '',
              priceUnit: ''
            }
          ]
          if (v.rentType === 0) {
            // 按整房出租
            this. rentPriceUnitList = [
              {code: '2', name: '元 / 间 / 月'},
              {code: '1', name: '元 / 间 / 天'},
            ]
            this.rentPriceUnit = '2'
          } else {
            // 按床位出租
            bedsListInRoom = v.beds || []
            this. rentPriceUnitList = [
              {code: '4', name: '元 / 床 / 月'},
              {code: '3', name: '元 / 床 / 天'},
            ]
            this.rentPriceUnit = '4'
          }
          this.addAllocateListings.rooms = room
          this.bedsListInRoom = bedsListInRoom
        }
      })
    },

    beforeDownload () {
      this.exportUrl = `${api.exportEnterpriseInfo}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&rentStatus=${this.requestData.rentStatus}`
    },
    uploadSuccess (data) {
      const e = errorHandler('导入失败')(data)
      if (!(e instanceof Error)) {
        nSuccess('导入成功')
        this.getPage()
      }
    },
    getPage () {
      let reqData = this.requestData
      reqData.pageNum = this.pageNum
      reqData.pageSize = this.pageSize
      this.$axios.post(api.getEnterpriseLeasePage, reqData)
        .then(res => {
          let data = res.data.data.list
          this.total = res.data.data.total - 1
          data.map((v, i) => {
            let leaseRoomBindList = v.leaseRoomBindList || []
            leaseRoomBindList.map(leaseRoom => {
              leaseRoom.leaseRoomNumberLabel = `${leaseRoom.buildingName}/${leaseRoom.floorName}层/${leaseRoom.roomNumber}`
            })
            v.rentTypeText = v.rentType === 1 ? '床位' : '整租'
            if (v.status === 0) {
              v.statusText = '申请中'
            } else if (v.status === 1) {
              v.statusText = '已通过'
            } else if (v.status === 2) {
              v.statusText = '已驳回'
            } else if (v.status === 3) {
              v.statusText = '已撤回'
            } else if (v.status === 4) {
              v.statusText = '已作废'
            }
          })
          this.tableData = data
        })
        .catch(errorHandler('获取单位信息失败'))
    },
    search (v) {
      this.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey (v) {
      this.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
    toCurrentPage (code) {
      this.$router.push({
        path: `/business_current/${code}`
      })
    },
    deleteSelection () {
      if (this.selectionArr.length === 0) {
        nAlert('请先选择需要删除的单位')
        return false
      } else {
        this.$confirm('确定删除已选中的单位？', '提示')
          .then(() => {
            this.deleteLine(this.selectionArr)
          })
          .catch(() => {
            console.log('取消删除')
          })
      }
    },
    deleteLine (code) {
      this.$axios.post(api.delEnterpriseLeaseByCodes, code)
        .then(res => {
          nSuccess('删除成功')
          this.selectionArr = []
          this.getPage()
        })
        .catch(errorHandler('删除失败'))
    },

    showAllocateListingsVisible (data) {
      this.addAllocateListings.rooms = []
      this.leaseStartTime = ''
      this.leaseStopTime = ''
      this.allocateListingsRoomCode = ''
      this.bedChooseCode = ''
      this.bedsListInRoom = []
      this.rentPrice = ''
      this.rentPriceUnitList = [
        {code: '2', name: '元 / 间 / 月'},
        {code: '1', name: '元 / 间 / 天'},
      ]
      this.rentPriceUnit = '2'
      this.allocateListingsRoomCode = ''
      this.addAllocateListings.code = data.code
      this.allocateListingsVisible = true
    },

    allotEnterpriseLeaseRoom () {
      if (!this.allocateListingsRoomCode) {
        nError('请选择房间')
        return false
      }
      if (!this.bedChooseCode && this.bedsListInRoom.length > 0) {
        nError('请选择床位')
        return false
      }
      if (!this.leaseStopTime) {
        nError('请选择租赁结束时间')
        return false
      }
      if (!this.leaseStartTime) {
        nError('请选择租赁起始时间')
        return false
      }
      if (!this.leaseStopTime) {
        nError('请选择租赁结束时间')
        return false
      }
      let beds = []
      if (this.bedChooseCode && this.bedsListInRoom.length > 0) {
        this.bedsListInRoom.map(bed => {
          if (this.bedChooseCode.indexOf(bed.code) !== -1) {
            beds.push({code: bed.code, bedsNumber: bed.bedsNumber})
          }
        })
      }
      this.addAllocateListings.rooms[0].beds = beds
      this.addAllocateListings.rooms.map(room => {
        room.leaseStartTime = this.leaseStartTime
        room.leaseStopTime = this.leaseStopTime
        room.price = this.rentPrice
        room.priceUnit = this.rentPriceUnit
        room.beds.map(bed => {
          bed.leaseStartTime = this.leaseStartTime
          bed.leaseStopTime = this.leaseStopTime
          bed.price = this.rentPrice
          bed.priceUnit = this.rentPriceUnit
        })
      })
      this.$axios.post(api.allotEnterpriseLeaseRoom, this.addAllocateListings)
        .then(res => {
          nSuccess('操作成功')
          this.allocateListingsVisible = false
          this.getPage()
        })
        .catch(errorHandler('操作失败'))
    },

    // 展示修改信息
    showModifyAllocateListingsVisible (data) {
      this.modifyAddAllocateListings = deepCloneFunction(data)
      if (this.modifyAddAllocateListings.bedsNumber) {
        this.modifyRentPriceUnitList = [
          {code: '4', name: '元 / 床 / 月'},
          {code: '3', name: '元 / 床 / 天'},
        ]
      } else {
        this.modifyRentPriceUnitList = [
          {code: '2', name: '元 / 间 / 月'},
          {code: '1', name: '元 / 间 / 天'},
        ]
      }
      this.modifyAllocateListingsVisible = true
    },

    // 修改房源信息
    updateLeaseRoomBind () {
      this.$axios.post(api.updateLeaseRoomBind, this.modifyAddAllocateListings)
        .then(res => {
          this.modifyAllocateListingsVisible = false
          nSuccess('修改成功')
          this.getPage()
        })
        .catch(errorHandler('修改失败'))
    },

    // 房源解绑
    delLeaseRoomBindByCodes (data) {
      console.log(data)
      this.$confirm('是否确认解绑此房源？', "温馨提示", {
        type: "warning"
      })
        .then(() => {
          this.$axios.post(api.delLeaseRoomBindByCodes, [data.code])
            .then(res => {
              nSuccess('解绑成功')
              this.getPage()
            })
            .catch(errorHandler('解绑失败'))
        })
        .catch(() => {
          console.log("取消删除");
        });
    },
  },
  watch: {}
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/BusinessManagement/BusinessManagement.vue